import { PageHeader, Upload } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { EMPTY_EQPT } from 'domains/eqptDomain';
import { isPlatformOrg } from 'domains/orgDomain';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';

export const EqptHeader = () => {
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.eqpt.item);
  const filterObj = useAppSelector((state) => state.eqpt.filterObj);
  const currentPage = useAppSelector((state) => state.eqpt.currentPage);

  const importLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.importEquipments
  );
  const exportLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.exportEquipments
  );

  const importFile = (
    <Upload
      maxCount={1}
      disabled={importLoading}
      showUploadList={false}
      customRequest={async (option) => {
        const formData = new FormData();
        formData.append('file', option.file);
        await dispatch.excelDefinition.importEquipments(formData);
        if (+currentPage === 1) {
          await dispatch.eqpt.getList({
            page: {
              currentPage: 1,
              pageSize: 20,
            },
            query: {
              ...filterObj,
            },
          });
        } else {
          dispatch.eqpt.setState({
            currentPage: 1,
          });
        }
      }}
    >
      <RevxButton key="import" brandGreen loading={importLoading}>
        {t('common.import')}
      </RevxButton>
    </Upload>
  );

  const exportFile = (
    <RevxButton
      key="export"
      brandGreen
      loading={exportLoading}
      onClick={() => {
        dispatch.excelDefinition.exportEquipments();
      }}
    >
      {t('common.export')}
    </RevxButton>
  );

  const createButton = (
    <RevxButton
      key="create"
      brandGreen
      disabled={!!curItem}
      onClick={() => {
        if (!isBaseOrg) {
          dispatch.eqpt.setEqptBaseSelectVisible(true);
        } else {
          dispatch.eqpt.setState({ item: EMPTY_EQPT });
        }
      }}
    >
      {isBaseOrg
        ? t('platform.eqpt.createBaseEqpt')
        : t('platform.eqpt.createEqptFromBase')}
    </RevxButton>
  );

  return (
    <PageHeader
      ghost={false}
      title={
        isBaseOrg
          ? t('platform.header.baseEquipments')
          : t('platform.header.equipments')
      }
      className="platform-page-header"
      extra={[exportFile, importFile, createButton]}
    />
  );
};
